<app-common-page-breadcrumbs [pageTitle]="title" [navigationData]="navigationData"></app-common-page-breadcrumbs>
<div *ngIf="enableLoader" id="loader"></div>
<div class="container py-4">
  <div *ngIf="!enableLoader">
    <form (ngSubmit)="submitForm()" [formGroup]="loginForm">
      <div class="row">
        <div class="col-md-1 col-sm-auto">

        </div>
        <div class="col-md-3 col-sm-auto ml-3">
          <div *ngIf="privacy?.smsEnabled">
            <div class="row pb-3">
              <span class="strong">{{'home.loginForm.emailAddress.selectOTPMethodDescription' | cxTranslate }}</span>
            </div>
            <div class="row">
              <div class="form-group form-check form-check-inline">
                <input required class="form-check-input" formControlName="otpMethod" type="radio"
                  name="inlineRadioOptions" id="Email" value="Email">
                <label class="form-check-label pb-2" for="inlineRadio1">{{'home.loginForm.email' | cxTranslate
                  }}</label>
              </div>
              <div class="form-group form-check form-check-inline">
                <input required class="form-check-input" formControlName="otpMethod" type="radio"
                  name="inlineRadioOptions" id="SMS" value="SMS">
                <label class="form-check-label pb-2" for="inlineRadio2">{{'home.loginForm.SMS' | cxTranslate }}</label>
              </div>
              <cx-form-errors [control]="loginForm.get('otpMethod')" prefix="home"></cx-form-errors>
            </div>
            <div class="row">
              <p class="">{{'home.loginForm.NotSupportingCountriesLabelBefore' | cxTranslate }}</p> &nbsp;
              <a class="primary" [ngClass]="{'disabled' : privacy?.showSMSCountryPopup == false}"
                (click)="openCountriesList()">{{'home.loginForm.NotSupportingCountriesLabel' | cxTranslate }}</a> &nbsp;
              <p class="">{{'home.loginForm.NotSupportingCountriesLabelAfter' | cxTranslate }}</p>
            </div>
          </div>


        </div>
        <div *ngIf="privacy?.smsEnabled" class="col-md-1 col-sm-auto">

        </div>
        <div class="col-md-4 col-sm-auto">
          <div class="form-group">
            <label>
              <span class=" strong">{{'home.loginForm.emailAddress.label' | cxTranslate }}</span>
              <div class="small text-secondary  mb-2">{{ 'home.loginForm.format' | cxTranslate }}</div>
              <input type="email" class="form-control form-control-lg text-secondary " formControlName="userId"
                placeholder="{{ 'home.loginForm.emailAddress.placeholder' | cxTranslate }}" />
              <cx-form-errors [control]="loginForm.get('userId')" prefix="home"></cx-form-errors>
            </label>
          </div>
          <div class="form-group">
            <label>
              <span class=" strong">{{'home.loginForm.password.label' | cxTranslate }}</span>
              <input type="password" class="form-control form-control-lg text-secondary  mt-2"
                placeholder="{{ 'home.loginForm.password.placeholder' | cxTranslate }}" formControlName="password" />
              <cx-form-errors [control]="loginForm.get('password')" prefix="home"></cx-form-errors>
            </label>
          </div>
          <p>
            <a [routerLink]="{ cxRoute: 'forgotPassword' } | cxUrl" aria-controls="reset-password"
              class="small text-secondary text-decoration-underline text-black">{{ 'home.loginForm.forgotPassword' |
              cxTranslate }}</a>
          </p>
           <div class="row">
         <div *ngIf="privacy?.enableKMLI" class="pb-3 ml2 col-md-6" >
        <input [checked]="isKeepLoggedIn" (change)="isKeepLoggedIn = $event.target.checked" type="checkbox" id="keepLoggedIn" name="keepLoggedIn">
        <label for="keepLoggedIn">{{ 'home.loginForm.keepLoggedIn' | cxTranslate }}</label>
        </div>
      </div>

          <button type="submit" [disabled]="isDisabled" class="btn btn-lg btn-block btn-primary rounded-1 md-font">
            {{ 'home.loginForm.signIn' | cxTranslate }}
          </button>
          <p class="py-2">
            {{'home.loginForm.TroubleSignIn' | cxTranslate}}

          </p>

        </div>
        <div class="col-md-3 col-sm-auto">
        </div>
      </div>
    </form>
    <div class="row">
      <div class="col-md-4 col-sm-auto ml-3">

      </div>
      <div *ngIf="privacy?.smsEnabled" class="col-md-1 col-sm-auto">

      </div>
      <div class="col-md-4 col-sm-auto">
        <button class="btn btn-lg btn-block btn-primary rounded-1 md-font" (click)="login()"
          [disabled]="!(isGigyaReady$ | async)">{{ 'home.loginForm.Biometrics.loginWithPasskey' | cxTranslate }}</button>
      </div>
      <div class="col-md-3 col-sm-auto">

      </div>
    </div>
    <!-- <div class="row">


<div class="col-md-2 col-6">
      <button class="btn btn-block btn-primary" (click)="register()">Register Fido</button>
    </div>
    
    <div class="col-md-2 col-6">
      <button type="button" class="btn btn-block btn-light background-face-btn" (click)="getFaceCredentials()">
        <img src="/images/faceid.svg" class="mr-2" /> Get Credentials
      </button>
    </div>
    <div class="col-md-2 col-6">
    <button class="btn btn-block btn-secondary" (click)="removeCredentials()">remove Credentials</button>
    </div>
    
  <div class="col-md-2 col-6">
    <button class="btn btn-block btn-secondary" (click)="loginCDC()">login using cdc</button>
    
    </div>
    <div class="col-md-2 col-6">
    <button class="btn btn-block btn-secondary" (click)="showScreenSet()">showscreen</button>
    
    </div>
    <div class="col-md-2 col-6">
    <button class="btn btn-block btn-secondary" (click)="test()">test</button>
    
    </div>
     <button class="btn btn-sm btn-block btn-outline-info" onclick="gigya.accounts.showScreenSet({screenSet:'Default-PasswordlessLogin', startScreen:'gigya-passwordless-register-screen'});">Register with passkey</button>
  
  
  
  </div>  -->

  </div>
</div>



<!-- <div *ngIf="notValidCreds" class="text-danger text-center mt-3 strong ">{{loginData.error}}</div> -->